import * as pages from 'careers/pages'
import CareersApp from 'careers/app'
import Error404 from 'components/errors/404'
import { parse as qs } from 'qs'

export default onEnter => ([
  {
    path: '/careers/linked-in/callback',
    onEnter: (routerState, redirect) => {
      let { search } = routerState.location
      if (search[0] === '?') {
        search = search.substring(1)
      }
      const query = qs(search)
      const lang = window.sessionStorage.getItem('careersLang')
      const companyId = window.sessionStorage.getItem('careersCompany')
      const jobAdId = window.sessionStorage.getItem('careersJobAd')
      const csrfToken = window.sessionStorage.getItem('careersCsrf')

      window.sessionStorage.removeItem('careersLang')
      window.sessionStorage.removeItem('careersCompany')
      window.sessionStorage.removeItem('careersJobAd')
      window.sessionStorage.removeItem('careersCsrf')

      const { error, code } = query
      const returnedCsrfToken = query.state

      if (
        csrfToken !== returnedCsrfToken
        || !lang
        || !companyId
        || !jobAdId
      ) {
        redirect('/careers/403')
      } else if (error) {
        redirect(`/careers/${lang}/${companyId}/${jobAdId}/apply?linkedInError=${error}`)
      } else {
        redirect(`/careers/${lang}/${companyId}/${jobAdId}/apply?linkedInCode=${code}`)
      }
    },
  },
  {
    path: '/careers/:language',
    component: CareersApp,
    indexRoute: {
      component: Error404,
    },
    childRoutes: [
      {
        path: ':companySlug',
        component: pages.Index,
        onEnter,
      },
      {
        path: ':companySlug/:adSlug',
        component: pages.JobAd,
        onEnter,
        indexRoute: {
          component: pages.JobAdDetails,
        },
        childRoutes: [
          {
            path: 'apply',
            component: pages.JobAdApply,
            onEnter,
          },
          {
            path: 'interview',
            component: pages.JobAdQuickInterview,
            onEnter,
          },
          {
            path: 'thankyou',
            component: pages.JobAdThankYou,
            onEnter,
          },
          {
            path: 'seeyou',
            component: pages.JobAdSeeYou,
            onEnter,
          },
          {
            path: 'application/:token',
            component: pages.ContinueApplication,
            onEnter,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    component: Error404,
  },
])
